/**
 * FileViewerApp Definition
 */

import { FileText } from '@phosphor-icons/react';
import type { AppDefinition } from '../../types/apps';

const FileViewerAppDefinition: AppDefinition = {
  appId: 'file-viewer',
  name: 'File Viewer',
  description: 'View file contents with syntax highlighting',
  icon: {
    type: 'component',
    component: FileText,
    componentProps: {
      weight: 'duotone',
      color: '#3b82f6' // River blue accent
    }
  },
  version: '1.0.0',
  component: 'file-viewer',
  entityTypes: [
    'File.Code.*',
    'File.Data.*',
    'File.Document.Text',
    'File.Document.Markdown',
    'File.Audio.*',
    'File.Archive.*'
  ],
  requiresProps: true,
  requiresEntity: true
};

export default FileViewerAppDefinition;
